import React from 'react';
import icon from ".../images/icon.png"


// 정확한 날짜 표시 (예: 2025.03.10)
export function DateFormatExact ( value: any ) {
  if (!value) return '';
  const str = String(value);
  // 'yyyy-MM-dd' 형식 문자열은 시간대 변환 없이 그대로 사용
  const plain = str.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (plain) {
    return `${plain[1]}.${plain[2]}.${plain[3]}`;
  }
  const date = new Date(str);
  if (isNaN(date.getTime())) return str;
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}.${mm}.${dd}`;
}

export default function DateFormmating ( props: any ) {

  const targetDate = new Date(props).getTime();
  const currentDate = new Date().getTime();
  const differenceInMilliseconds = currentDate - targetDate;

  const minutes = Math.floor(differenceInMilliseconds / (1000 * 60));
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const months = Math.floor(days / 31);

  if (months > 0) {
      return `${months}달 전`;
  } else if (days > 0) {
      return `${days}일 전`;
  } else {
      return `오늘`;
  } 

}
